import styled from 'styled-components';
import { Link } from 'react-router-dom';
import Typography from '../../../../../kingpin/atoms/Typography';

const FieldUsageEntityContainer = styled.div`
  display: block;
`;

const FieldUsageEntity = ({ link, name }: { link?: string; name: string }) => {
  return (
    <FieldUsageEntityContainer>
      {link && (
        <Link style={{ fontSize: 12 }} to={link} target={'_blank'}>
          {name}
        </Link>
      )}
      {!link && <Typography.Body type={'Body 12'}>{name}</Typography.Body>}
    </FieldUsageEntityContainer>
  );
};

export default FieldUsageEntity;
